import { render, staticRenderFns } from "./TrafiklabWidget.vue?vue&type=template&id=f3e18664&scoped=true"
import script from "./TrafiklabWidget.vue?vue&type=script&lang=js"
export * from "./TrafiklabWidget.vue?vue&type=script&lang=js"
import style0 from "./TrafiklabWidget.vue?vue&type=style&index=0&id=f3e18664&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e18664",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3e18664')) {
      api.createRecord('f3e18664', component.options)
    } else {
      api.reload('f3e18664', component.options)
    }
    module.hot.accept("./TrafiklabWidget.vue?vue&type=template&id=f3e18664&scoped=true", function () {
      api.rerender('f3e18664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/designer/widgets/TrafiklabWidget.vue"
export default component.exports